export default __webpack_public_path__ + "static/media/o.e360ce85.jpg";